import { useEffect, useState } from 'react';

/** The current time, refreshed every `intervalMs`, for copy like "started 12 minutes ago". */
export const useNow = (intervalMs: number) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);

  return now;
};
